import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { postAPI } from "../service/http-service";
import { AuthApi } from "../auth/authEndpointConfig/AuthEndpointConfig";

export interface verifyOTPProps {
  email: string;
  mobileNo: any;
  otp: number;
}

let initialState: any = {
  loading: false,
  entity: {
    resetPassResponse: "",
  },
};

//Verify OTP API call
export const verifyOTP = createAsyncThunk(
  "auth/verifyOTP",
  async (requestParam: verifyOTPProps) => {
    try {
      const response = await postAPI(AuthApi.verifyOTP, requestParam);
      return response;
    } catch (err) {
      return err;
    }
  }
);
const verifyOTPSlice = createSlice({
  name: "verifyOTP",
  initialState,
  reducers: {
    addObj: (state, action: any) => {
      state.entity.push({ success: false });
    },
  },
  extraReducers: (builder) => {
    builder.addCase(verifyOTP.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(verifyOTP.fulfilled, (state, action) => {
      state.entity.resetPassResponse = action.payload;
      state.loading = false;
    });
    builder.addCase(verifyOTP.rejected, (state, action) => {
      if (action.payload) {
        state.entity = action.payload;
      } else {
        state.error = action.error.message;
      }
    });
  },
});

const verifyOTPReducer = verifyOTPSlice.reducer;
export default verifyOTPReducer;
